import React from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import LinkWidgetSettings from "../WidgetsSettings/WebWidgets/LinkWidgetWeb/LinkWidgetSettingsModal";
import { Divider } from "../../BP2Components";
import IntlMessages from "@util/IntlMessages";

const LinkWidget = ({ value, role }) => {
   return (
      <Widget
         styleName="gx-m-0"
         bgColor={value.backgroundColourHex}
         title={value.linkWidgetTitleTranslationKey}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={<LinkWidgetSettings value={value} />}
               />
            )
         }
      >
         <strong>
            <IntlMessages id="settings.linkWidgetTitleTranslationKey" /> :
         </strong>{" "}
         {value.linkWidgetTitleTranslationKey}
         <Divider />
         <strong>
            <IntlMessages id="settings.widgetKey" /> :
         </strong>{" "}
         {value.widgetKey}
         <Divider />
         <strong>
            {" "}
            <IntlMessages id="settings.links" /> :
         </strong>
         <p>
            <ul>
               {value.links.map((link) => (
                  <li>{link.linkTitleTranslationKey}</li>
               ))}
            </ul>
         </p>
      </Widget>
   );
};

export default LinkWidget;
